import { COLORS } from "common/colors";

export const GRAPHS = {
  getColumnGraph: (
    title: string,
    xAxis: string[],
    yAxis: number[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "column",
        height,
        panning: true,
        marginLeft: 60,
        lang: {
          decimalPoint: ".",
          thousandsSep: ",",
        },
        options3d: {
          enabled: true,
          alpha: 0,
          beta: 10,
          viewDistance: 25,
          depth: 60,
        },
      },
      credits: false,
      title: {
        align: "center",
        text: title || "",
      },
      exporting: {
        filename: exportTitle || new Date().getTime().toString(),
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        categories: xAxis,
        title: {
          text: xAxisTitle, //"Number of Reports",
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: yAxisTitle, //"Number of Reports",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{point.y:.0f}",
          },
        },
        column: {
          colorByPoint: true,
        },
      },
      tooltip: {
        headerFormat:
          '<span style="font-size:11px;font-weight:bold;">{point.key}</span><br>',
        pointFormat: "Value: <b>{point.y:.1f}</b><br/>",
      },
      series: [
        {
          name: "Category",
          data: yAxis,
          color: COLORS.PRIMARY,
        },
      ],
    };
  },

  getPieGraph: (
    title: string,
    series: any[],
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "pie",
        height,
        marginTop: 40,
        marginLeft: 85,
        options3d: {
          enabled: true,
          alpha: 45,
        },
      },
      credits: false,
      title: {
        text: title,
      },
      exporting: {
        filename: exportTitle,
      },
      tooltip: {
        pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      plotOptions: {
        pie: {
          innerSize: 100,
          depth: 45,
        },
      },
      series,
    };
  },

  getStackedBar: (
    title: string,
    xAxis: string[],
    yAxis: number[],
    series: any[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,

    height?: number
  ) => {
    return {
      chart: {
        type: "bar",
        height,
      },
      title: title,
      xAxis: {
        categories: ["North", "South"],
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
        },
      },
      credits: {
        enabled: false,
      },
      legend: false,
      plotOptions: {
        series: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
          },
        },
      },
      series,
    };
  },

  getSolidGauge: (
    title: string,
    series: any[],
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "solidgauge",
        height,
      },
      title: title,
      credits: {
        enabled: false,
      },
      pane: {
        center: ["50%", "85%"],
        size: "140%",
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: "#EEE",
          innerRadius: "60%",
          outerRadius: "100%",
          shape: "arc",
        },
      },
      exporting: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },

      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        title: {
          text: "Pending Action",
        },
        stops: [
          [0.0, "#55BF3B"], // green
          [0.0, "#DDDF0D"], // yellow
          [0.0, "#DF5353"], // red
        ],
        lineWidth: 0,
        tickWidth: 0,
        minorTickInterval: null,
        tickAmount: 2,
        title2: {
          y: -70,
        },
        labels: {
          y: 16,
        },
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true,
          },
        },
      },

      series,
    };
  },

  getBarGraph: (
    title: string,
    xAxis: string[],
    yAxis: number[],
    xAxisTitle: string,
    yAxisTitle: string,
    exportTitle?: string,
    height?: number
  ) => {
    return {
      chart: {
        type: "bar",
        height,
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: xAxis,
        title: {
          text: xAxisTitle,
        },
        gridLineWidth: 1,
        lineWidth: 0,
      },
      yAxis: {
        min: 0,
        title: {
          text: yAxisTitle,
          align: "high",
        },
        labels: {
          overflow: "justify",
        },
        gridLineWidth: 0,
      },
      // tooltip: {
      //     valueSuffix: ' millions'
      // },
      plotOptions: {
        bar: {
          borderRadius: "1.5%",
          dataLabels: {
            enabled: true,
          },
          groupPadding: 0.35,
        },
      },
      exporting: {
        filename: exportTitle || new Date().getTime().toString(),
      },
      legend: false,
      credits: {
        enabled: false,
      },
      series: [
        {
          data: yAxis,
        },
      ],
    };
  },
};
